import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

function assertResult (response) {
  const result = response && response.data ? response.data.result : null
  if (result !== 'OK' && result !== true) {
    throw new Error((response && response.data && response.data.message) || 'Operación no completada')
  }
}

export default {
  async getOperations (companyId) {
    const [addressesResponse, contractsResponse, bankAccountsResponse, comunasResponse] = await Promise.all([
      api.get('company/getAddresses', { params: { company_id: companyId } }),
      api.get('company/getContracts', { params: { company_id: companyId } }),
      api.get('company/getBankAccounts', { params: { company_id: companyId } }),
      api.get('comunas/getComunas')
    ])

    return {
      addresses: addressesResponse.data.addresses || [],
      contracts: contractsResponse.data.contracts || [],
      bankAccounts: bankAccountsResponse.data.bank_accounts || [],
      comunas: comunasResponse.data.comunas || []
    }
  },

  async getAddress (addressId) {
    const response = await api.get('company/getAddress', { params: { address_id: addressId } })
    return response.data.address
  },

  async createAddress (payload) {
    const response = await api.post('company/createAddress', { address: payload })
    assertResult(response)
    return response.data.address || payload
  },

  async updateAddress (payload) {
    try {
      const response = await api.post('company/updateAddress', { address: payload })
      assertResult(response)
      return response.data.address || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createAddress', { address: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.address || payload
    }
  },

  async deleteAddress (addressId) {
    const response = await api.post('company/deleteAddress', { address: { id: addressId } })
    assertResult(response)
    return true
  },

  async getContract (contractId) {
    const response = await api.get('company/getContract', { params: { contract_id: contractId } })
    return response.data.contract
  },

  async createContract (payload) {
    const response = await api.post('company/createContract', { contract: payload })
    assertResult(response)
    return response.data.contract || payload
  },

  async updateContract (payload) {
    try {
      const response = await api.post('company/updateContract', { contract: payload })
      assertResult(response)
      return response.data.contract || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createContract', { contract: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.contract || payload
    }
  },

  async deleteContract (contractId) {
    const response = await api.post('company/deleteContract', { contract: { id: contractId } })
    assertResult(response)
    return true
  },

  async getBankAccount (bankAccountId) {
    const response = await api.get('company/getBankAccount', { params: { bank_account_id: bankAccountId } })
    return response.data.bank_account
  },

  async createBankAccount (payload) {
    const response = await api.post('company/createBankAccount', { bank_account: payload })
    assertResult(response)
    return response.data.bank_account || payload
  },

  async updateBankAccount (payload) {
    try {
      const response = await api.post('company/updateBankAccount', { bank_account: payload })
      assertResult(response)
      return response.data.bank_account || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createBankAccount', { bank_account: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.bank_account || payload
    }
  },

  async deleteBankAccount (bankAccountId) {
    const response = await api.post('company/deleteBankAccount', { bank_account: { id: bankAccountId } })
    assertResult(response)
    return true
  }
}
